import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ISendTypeConfiguration } from "../../../../../../core/interfaces/send-type-configuration";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-product-card",
  templateUrl: "./product-card.component.html",
  styleUrls: ["./product-card.component.scss"]
})
export class ProductCardComponent implements OnInit{

  @Input() product!: ISendTypeConfiguration;
  @Input() selected: boolean = false;
  @Input() invalid: boolean = false;
  
  /**
   * Modalità compatta - riduce font e spaziature quando ci sono molte card in riga
   * Attivata automaticamente quando ci sono 4+ prodotti
   */
  @Input() compact: boolean = false;

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSelect: EventEmitter<ISendTypeConfiguration> =
    new EventEmitter<ISendTypeConfiguration>();

  constructor() {
  }
  ngOnInit(): void {
    const primaryColor = environment.brand.type === 'plusdigital' ? 'var(--brand-secondary)' : '#007bff';
      document.documentElement.style.setProperty('--primary-color', primaryColor);
  }

}
